import { ChangeDetectionStrategy, Component, ElementRef, ViewChild } from '@angular/core';
import { fromEvent, map, merge, Subject, takeUntil } from 'rxjs';
import { DataGridService } from '../data-grid.service';

@Component({
  selector: 'ss-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  host: {
    class: 'display-block'
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchComponent {
  readonly #destroy = new Subject<void>()

  @ViewChild('searchInput')
  private _searchInput: ElementRef<HTMLInputElement>

  readonly searchSubject = this._dataGridService.searchSubject;
  readonly showCollapsedModeSubject = this._dataGridService.showCollapsedModeSubject;

  constructor(
    private readonly _dataGridService: DataGridService
  ) {

  }


  ngAfterViewInit() {

    merge(
      fromEvent(this._searchInput.nativeElement, 'keyup'),
      fromEvent(this._searchInput.nativeElement, 'change')
    )

      .pipe(
        map(() => this._searchInput.nativeElement.value),
        takeUntil(this.#destroy)
      )
      .subscribe((value) => {

        this.searchSubject.next(value)
      })


    this._searchInput.nativeElement.focus();
    this._searchInput.nativeElement.select();
  }




  ngOnDestroy() {
    this.#destroy.next()
    this.#destroy.complete()
  }
}
